import authorizedAPIInstance from '@/api/authorizedAPI';
import { formatAPIError, replacePlaceholders } from '@/utils/helpers';
import type {
  ProductionReport,
  ProductionReportMeasurementInput,
} from '../utils/types';

export type ProductionReportByIdInput = {
  reportId: string;
};

export const fetchProductionReportById = async ({
  reportId,
}: ProductionReportByIdInput): Promise<ProductionReport> => {
  try {
    const { data } = await authorizedAPIInstance.get<ProductionReport>(
      replacePlaceholders(`/api/production-reports/:reportId`, {
        reportId,
      })
    );
    return data;
  } catch (error) {
    throw formatAPIError(error);
  }
};

export type ProductionReportInput = {
  production_period_id: string;
  measurements: Array<ProductionReportMeasurementInput>;
};

export type ProductionReportResponse = {
  production_period_id: string;
  measurements: Array<ProductionReportMeasurementInput>;
  total: number;
};

export const reportProductionPeriod = async (
  body: ProductionReportInput
): Promise<ProductionReportResponse> => {
  try {
    const { data } = await authorizedAPIInstance.post<ProductionReportResponse>(
      '/api/production-reports',
      body
    );
    return data;
  } catch (error) {
    throw formatAPIError(error);
  }
};
